import { useAtom } from 'jotai';
import tinycolor from 'tinycolor2';

import { themeAtom } from '../State';
import { baseColor } from './palette';

/**
 * Die Hausfarbe, auf der die CBOS-Farbfamilie steht — als React-Wert.
 *
 * Warum nicht die CSS-Variable: `CustomerThemeProvider` holt das Thema in einem `useEffect` und
 * rendert seine Kinder **vorher**. Wer die Farbe während des Renderns aus dem Stylesheet liest,
 * liest sie, bevor sie dort steht, bekommt den Rückfallwert — und erfährt nie, dass sie
 * nachgereicht wurde, weil an einer CSS-Variablen nichts hängt, das ein erneutes Zeichnen auslöst.
 * Genau so blieb die Phasenleiste auf dem alten Marineblau stehen, obwohl die Farbe längst richtig
 * gesetzt war.
 *
 * Über das Atom stimmt beides: Es liegt in `atomWithStorage`, ist beim Neuladen also sofort
 * belegt, und wenn der Abruf eine andere Farbe bringt, zeichnen die Ansichten neu.
 */
export const useBrandBase = (): string => {
    const [theme] = useAtom(themeAtom);
    const primary = (theme as any)?.primary;

    if (typeof primary !== 'string' || !primary.trim()) return baseColor;

    const parsed = tinycolor(primary);

    // Die Farbe ist mit Alpha-Suffix gespeichert (`#0c2c65ff`); `toHexString` schneidet es ab.
    return parsed.isValid() ? parsed.toHexString() : baseColor;
};
